import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from "../components/HeroSection";
import ProductShowcase from "../components/ProductShowcase";
import ValueProposition from "../components/ValueProposition";
import Testimonials from "../components/Testimonials";
import ContactSection from "../components/ContactSection";
import WhatsAppFloat from "../components/WhatsAppFloat";
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Home = () => {
  const { t } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFirstVisit, setIsFirstVisit] = useState(false);

  useEffect(() => {
    // Check if user has already seen animations in this session
    const hasVisited = sessionStorage.getItem('home_visited');
    if (!hasVisited) {
      setIsFirstVisit(true);
      sessionStorage.setItem('home_visited', 'true');
    }
    
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/products`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      setProducts(t.products.variants || []);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://griyabakpia.com/" />
      </Helmet>

      <div className={`min-h-screen ${!isFirstVisit ? 'no-animations' : ''}`}>
        <HeroSection />
        
        {/* Product Showcase Section - Data is fetched here and passed down */}
        <ProductShowcase products={products} loading={loading} />
        
        <ValueProposition />
        <Testimonials />
        <ContactSection />
        <WhatsAppFloat />
      </div>
    </>
  );
};

export default Home;
